class LocalisationForm extends HTMLElement {
  constructor() {
    super();
    document.querySelector('[data-ignore]')?.addEventListener('click', () => {
      this.setIgnoreLocalePopup();
    });

    this.getGeoLocation();

    document.querySelector('#show_country_selector')?.addEventListener('click', () => {
      this.toggleModal();
    });

    //add a event to data-submit to update the localization
    this.querySelector('[data-submit]')?.addEventListener('click', () => {
      const selectedOption = this.querySelector('#country_select').selectedOptions[0];
      if (selectedOption.dataset.alternateUrl) {
        console.log('redirecting to', selectedOption.dataset.alternateUrl);
        window.location.href = selectedOption.dataset.alternateUrl;
        return false;
      } else {
        this.updateLocalization(this.querySelector('#country_select').value);
      }
    });
  }

  toggleModal() {
    document.querySelector('#langmodal')?.classList.toggle('hidden');
  }

  setIgnoreLocalePopup() {
    const d = new Date();
    d.setTime(d.getTime() + 5 * 24 * 60 * 60 * 1000); // 5 days instead of 21
    let expires = 'expires=' + d.toUTCString();
    document.cookie = 'ignore_locale_popup=true;' + expires + ';path=/';

    this.toggleModal();
  }

  updateLocalization(country) {
    const formId = crypto.randomUUID();
    const formHtml = `
      <form id="${formId}" action="/localization" method="POST" hidden>
        <input name="_method" value="PUT">
        <input name="country_code" value="${country}">
      </form>
    `;
    document.body.insertAdjacentHTML('beforeend', formHtml);
    document.getElementById(formId).submit();
  }

  async getGeoLocation() {
    let redirectOutsideUs = false;
    if (window.Shopify?.country == 'US') {
      redirectOutsideUs = true;
    }

    try {
      if (!window.Shopify?.routes?.root) {
        console.warn('Missing required Shopify configuration');
        return;
      }

      const response = await fetch(
        window.Shopify.routes.root +
          'browsing_context_suggestions.json' +
          '?country[enabled]=true' +
          `&country[exclude]=${window.Shopify.country}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data) return;

      let suggestedCountry = null;
      if (data.suggestions?.length > 0 && data.suggestions[0]?.parts?.country?.handle) {
        suggestedCountry = data.suggestions[0].parts.country.handle;
      } else if (data.detected_values?.country?.handle) {
        suggestedCountry = data.detected_values.country.handle;
      }

      if (redirectOutsideUs && suggestedCountry != 'US') {
        suggestedCountry = 'NL';
      }

      if (!suggestedCountry) return;

      const countrySelect = this.querySelector('#country_select');

      if (countrySelect.value !== suggestedCountry) {
        if (!document.cookie.includes('ignore_locale_popup')) {
          this.toggleModal();
        }

        countrySelect.value = suggestedCountry;
        const selectedOption = countrySelect.selectedOptions[0];
        if (selectedOption) {
          selectedOption.text += ' (suggested)';
        }
      }
    } catch (error) {
      console.error('Error fetching geolocation data:', error);
    }
  }
}

if (!customElements.get('localisation-form')) {
  window.localForm = LocalisationForm;

  customElements.define('localisation-form', LocalisationForm);
}
